import { useContext } from "react";
import { useQuery } from "react-query";
import AppContext from "../appContext";
import * as api from "../services";

export const initErrorMessages = {
  loginMessage: {
    en: "We will be migrating",
  },
  headerCodes: {
    551: {
      en: "Migrating",
    },
  },
};

export default function useErrorMessages(props) {
  const {
    app: { sessionId },
  } = useContext(AppContext);
  const { data, isLoading, isError, refetch } = useQuery(
    ["errorMessages", sessionId],
    () => api.getErrorMessages({ sessionId }).then((data) => data),
    {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 1000 * 60 * 60 * 24,
      cacheTime: Infinity,
      placeholderData: () => initErrorMessages,
    }
  );

  return {
    headerCodes: data?.headerCodes ?? initErrorMessages.headerCodes,
    isLoading,
    isError,
    refetchMessages: refetch,
  };
}
